/**
 * Determines car availability status based on model status
 * @param status - The model status from modelDetails
 * @returns car_availability value for event tracking
 */
export const getCarAvailability = (status?: string): string => {
  if (status === "out_of_production") {
    return "Discontinued";
  }
  if (status === "non_sellable") {
    return "No";
  }
  return "Yes";
};

export const getCarAvailabilityOldFlow = (status?: string): string =>{
  if (status === "Out of Production") {
    return "Discontinued";
  }
  if (status === "On Sale"){
    return "Yes";
  }
  return "No"
}